import TableEditViewState from '../store/schema/TableEditViewState';

export default function createTableEditViewState(): TableEditViewState {
    return {
        position: null,
        hasHeaders: false,
    };
}
